import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  engagementTitle: {
    defaultMessage: 'Recommended based on your profile',
    description: 'Title for the engagement card feed',
    id: 'JWkYm6',
  },
  tutorial: {
    id: 'WQs1He',
    description: 'Text for button that indicates a tutorial video will play',
    defaultMessage: 'Watch Tutorial',
  },
  article: {
    id: 'iPPanY',
    description: 'Text for button that indicates an article will be displayed',
    defaultMessage: 'Read Article',
  },
  viewed: {
    id: 'DFIo9J',
    description: 'Text for a card that has been viewed',
    defaultMessage: 'Viewed',
  },
  oneMin: {
    id: 'LuPZYS',
    description: 'Text for a one minute card',
    defaultMessage: '1 min',
  },
  oneToTwoMins: {
    id: '1u9or7',
    description: 'Text for a one to two minute card',
    defaultMessage: '1-2 mins',
  },
  oneToFiveMins: {
    id: 'FOs7NY',
    description: 'Text for a one to five minute card',
    defaultMessage: '1-5 mins',
  },
  twoMins: {
    id: 'cKeFBT',
    description: 'Text for a two minute card',
    defaultMessage: '2 mins',
  },
  twoToThreeMins: {
    id: 'ijgJL1',
    description: 'Text for a two to three minute card',
    defaultMessage: '2-3 mins',
  },
  threeToFourMins: {
    id: 'j07sKE',
    description: 'Text for a three to four minute card',
    defaultMessage: '3-4 mins',
  },
  threeToFiveMins: {
    id: 'tKwRpd',
    description: 'Text for a three to five minute card',
    defaultMessage: '3-5 mins',
  },
  fiveToSevenMins: {
    id: 'sJSviw',
    description: 'Text for a five to seven minute card',
    defaultMessage: '5-7 mins',
  },
  viewAll: {
    id: 'c6QdZR',
    description: 'view all tag filter button text',
    defaultMessage: 'View All',
  },
  shipping: {
    id: 'sia2We',
    description: 'shipping tag filter button text',
    defaultMessage: 'Shipping',
  },
  orders: {
    id: 'fiCt9t',
    description: 'orders tag filter button text',
    defaultMessage: 'Orders',
  },
  international: {
    id: 'nQuiDF',
    description: 'international tag filter button text',
    defaultMessage: 'International',
  },
  returns: {
    id: 'ZuAlrx',
    description: 'returns tag filter button text',
    defaultMessage: 'Returns',
  },
  automations: {
    id: 'gjiQhW',
    description: 'automations tag filter button text',
    defaultMessage: 'Automations',
  },
  branding: {
    id: 'KlucKf',
    description: 'branding tag filter button text',
    defaultMessage: 'Branding',
  },
  postShip: {
    id: 'Fs9pka',
    description: 'post ship tag filter button text',
    defaultMessage: 'Post Ship',
  },
  inventory: {
    id: 'XMjaRV',
    description: 'inventory tag text',
    defaultMessage: 'Inventory',
  },
  reporting: {
    id: '08ZG1y',
    description: 'reporting tag text',
    defaultMessage: 'Reporting',
  },
  readArticle: {
    id: 'iPPanY',
    description: 'Text for button that indicates an article will be displayed',
    defaultMessage: 'Read Article',
  },
  create: {
    id: 'OYXCQF',
    description: 'Text for button that creates a new rule',
    defaultMessage: 'Create',
  },
  insuranceRuleName: {
    id: 'co06+e',
    description: 'Name for the insurance rule',
    defaultMessage: 'Insurance $50+',
  },
  weightRuleName: {
    id: 'SvFMON',
    description: 'Name for the weight rule',
    defaultMessage: 'Adjust for package weight',
  },
  createAShippingLabelTitle: {
    id: 'bwEZvr',
    defaultMessage: 'Create a shipping label',
    description: 'Title for the create a shipping label engagement card',
  },
  createAShippingLabelBody: {
    id: 'EhC5FF',
    description: 'Body for the create a shipping label engagement card',
    defaultMessage:
      'To create a label for an order, go to the Orders screen and enter the shipment details like weight, dimensions, and service. ShipStation will show you the rate and you can create & print the label right away.',
  },
  protectShipmentsTitle: {
    id: 'CkH9xp',
    description: 'Title for the Protect shipments with package insurance engagement card',
    defaultMessage: 'Protect shipments with package insurance',
  },
  protectShipmentsBody: {
    id: 'GPn1n7',
    description: 'Body for the Protect shipments with package insurance engagement card',
    defaultMessage:
      'Package insurance will protect you from financial loss due to lost or damaged shipments. Add package insurance directly in ShipStation before you create a label, using our partner’s discounted rates and simple claims process.',
  },
  storeLogoTitle: {
    id: 'FfvGMF',
    description: 'Title for the Add your store logo to your labels engagement card',
    defaultMessage: 'Add a store logo and company details',
  },
  storeLogoBody: {
    id: 'K+Dyym',
    description: 'Body for the Add your store logo to your labels engagement card',
    defaultMessage:
      'Once you upload your logo and add your other company details, they will appear on your notification emails, packing slips, and branded tracking and return pages. Multiple stores? No problem! Add a unique logo and details to each store.',
  },
  customizeEmailTitle: {
    id: 'dgblIq',
    description: 'Title for the Customize your email templates engagement card',
    defaultMessage: 'Customize your customer emails ',
  },
  customizeEmailBody: {
    id: 'JXNHXY',
    description: 'Body for the Customize your email templates engagement card',
    defaultMessage:
      "ShipStation includes a default email template for both Shipment and Delivery emails. The default template already includes store specific details from each store's Branding tab to the email, including your store logo image, company name, store name, phone, email address, and website.",
  },
  goToTemplates: {
    id: 'dbKRGY',
    description: 'Text for button that links to the email templates',
    defaultMessage: 'Go to templates',
  },
  syncOrdersTitle: {
    id: '16tGcQ',
    description: 'Title for the Sync orders from your store to ShipStation engagement card',
    defaultMessage: 'Keep your orders in sync',
  },
  syncOrdersBody: {
    id: '9qVtqx',
    description: 'Body for the Sync orders from your store to ShipStation engagement card',
    defaultMessage:
      'Once you connect a store, ShipStation will start importing orders regularly. To ensure you always see all your most recent orders, click the import icon [icon inline image] at any time. Order sync times vary depending on how many orders you have.',
  },
  compareRatesTitle: {
    id: 'raNl4D',
    description: 'Title for the Compare rates from different carriers engagement card',
    defaultMessage: 'Compare rates',
  },
  compareRatesBody: {
    id: '1TYzT1',
    description: 'Body for the Compare rates from different carriers engagement card',
    defaultMessage:
      'Compare rates between services and carriers using the Rate Browser. Enter shipment details like destination, weight, dimensions, and delivery speed to view what is available for that shipment.',
  },
  automationTutoriaTitle: {
    id: 'KCvxdH',
    description: 'Title for the Automation tutorial engagement card',
    defaultMessage: 'Save time by automating your work',
  },
  automationTutorialBody: {
    id: 'aUtMy2',
    description: 'Body for the Automation tutorial engagement card',
    defaultMessage:
      'ShipStation provides multiple ways to automate tasks you may be doing manually. You can save minutes per order, which could add up to hours each week!',
  },
  automationRecommendationWeightTitle: {
    id: 'erXTh8',
    description: 'Title for the Automation recommendation engagement card',
    defaultMessage: 'Recommended automation: Adjust for package weight',
  },
  automationRecommendationWeightBody: {
    id: 's76+1g',
    description: 'Body for the Automation recommendation engagement card',
    defaultMessage:
      'The packaging you ship with can increase total package weight beyond the weight of the items. This rule adds a set amount (3oz) to every shipment so your total shipment weight always accounts for the packaging.',
  },
  automationRecommendationInsuranceTitle: {
    id: 'DlCKnb',
    description: 'Title for the Automation recommendation for insurance engagement card',
    defaultMessage: 'Recommended automation: Insure all packages over $50',
  },
  automationRecommendationInsuranceBody: {
    id: 'F316iS',
    description: 'Body for the Automation recommendation for insurance engagement card',
    defaultMessage:
      "Many carriers limit their default coverage to $50 or less. This automation rule will add package insurance to any order with a total greater than $50 so you are protected from financial loss due to lost or damaged shipments. If you'd like to create a more targeted rule, we've included a link to an article that can help.",
  },
  createRule: {
    id: 'Fy0Xdb',
    description: 'Text for button that links to the create rule page',
    defaultMessage: 'Create Rule',
  },
  shipInternationallyTitle: {
    id: '81h0lV',
    description: 'Title for the Ship internationally engagement card',
    defaultMessage: 'Ship internationally',
  },
  shipInternationallyBody: {
    id: 'WEvWFy',
    description: 'Body for the Ship internationally engagement card',
    defaultMessage:
      'ShipStation provides the tools you need to successfully ship packages to international destinations. Print the necessary customs documentation along with the package label!',
  },
  internationalSettingsTitle: {
    id: 'ZSVXvE',
    description: 'Title for the International settings engagement card',
    defaultMessage: 'ShipStation International Settings',
  },
  internationalSettingsBody: {
    id: 'xKz7N6',
    description: 'Body for the International settings engagement card',
    defaultMessage:
      "ShipStation's International Settings control the default behavior for creating customs declarations for your shipments. The settings page lets you set defaults for non-delivery options, tax IDs, and marketplace tracking notification settings.",
  },
  goToSettings: {
    id: 'YZ6xOW',
    description: 'Text for button that links to the settings page',
    defaultMessage: 'Go to Settings',
  },
  brandedTrackingTitle: {
    id: 'Mat7rL',
    description: 'Title for the Branded tracking and returns engagement card',
    defaultMessage: 'Create a branded tracking experience',
  },
  brandedTrackingBody: {
    id: 'HDoSNm',
    description: 'Body for the Branded tracking and returns engagement card',
    defaultMessage:
      "ShipStation’s Branded Tracking Page lets your customers track their shipments on a page featuring your store's logo, colors, social media links, and more!",
  },
  returnLabelTitle: {
    id: 'iIXStJ',
    description: 'Title for the Create a return label engagement card',
    defaultMessage: 'Return labels',
  },
  returnLabelBody: {
    id: 'fIN+6t',
    description: 'Body for the Create a return label engagement card',
    defaultMessage:
      'Learn how to create individual return labels on demand, send return labels with your outgoing shipments, and use the Branded Returns Portal so your customers can self-service their returns.',
  },
  validateRecipientAddressTitle: {
    id: 'nDk0FL',
    description: 'Title for the Validate recipient address engagement card',
    defaultMessage: 'Validate recipient address',
  },
  validateRecipientAddressBody: {
    id: '1VHow3',
    description: 'Body for the Validate recipient address engagement card',
    defaultMessage:
      'ShipStation automatically validates the recipient addresses on your orders. If an address is unverified, check with your customer to help correct any possible mistakes before shipping.',
  },
  createCustomPackageTitle: {
    id: 'BNQmeN',
    description: 'Title for the create custom package engagement card',
    defaultMessage: 'Create custom packages',
  },
  createCustomPackageBody: {
    id: 'pBcBRd',
    description: 'Body for the create custom package engagement card',
    defaultMessage:
      'Many carriers require package dimensions to calculate the shipping cost. By creating custom packages, you can fill in the dimensions with a single click. Ensure accurate rates the first time to avoid potential adjustment charges later.',
  },
  addPackage: {
    id: 'peJ4fe',
    description: 'button test to open custom package modal',
    defaultMessage: 'Add package',
  },
  customizePackingSlipsTitle: {
    id: 'f7aoox',
    description: 'Title for the Customize your packing slips engagement card',
    defaultMessage: 'Customize your packing slips',
  },
  customizePackingSlipsBody: {
    id: 'f7/8pZ',
    description: 'Body for the Customize your packing slips engagement card',
    defaultMessage:
      'ShipStation lets you decide exactly what should be included, or not included, on your packing slips. Use basic customizations to hide prices for gift packing slips, or our advanced editor to design a template to your specifications.',
  },
  tagYourOrdersTitle: {
    id: '6E4gps',
    description: 'Title for the Tag your orders engagement card',
    defaultMessage: 'Tag your orders',
  },
  tagYourOrdersBody: {
    id: 'sMnJZg',
    description: 'Body for the Tag your orders engagement card',
    defaultMessage:
      'Add tags to help identify orders that need special attention. You can create as many tags as you need and add multiple tags to orders.',
  },
  tagYourOrdersSubText: {
    id: 'JjQygJ',
    description: 'Subtext for the Tag your orders engagement card',
    defaultMessage: 'Common tags include: Backordered, International, Pre-Order',
  },
  addTag: {
    id: 'zrmTMX',
    description: 'button text to open tag modal',
    defaultMessage: 'Add tag',
  },
  brandedReturnsPortalTitle: {
    id: 'IgN1pC',
    description: 'Title for the branded returns portal engagement card',
    defaultMessage: 'Branded Returns Portal',
  },
  brandedReturnsPortalBody: {
    id: 'elBG2R',
    description: 'Body for the branded returns portal engagement card',
    defaultMessage:
      'The Branded Returns Portal is a feature that allows your customers to generate a return label from your website at any time. Once you have the Branded Returns Portal enabled in your ShipStation account, you can add the unique URL to your website and email templates to create a customer-friendly returns process.',
  },
  selectLabelLayoutTitle: {
    id: 'NMCgoY',
    description: 'Title for the select label layout engagement card',
    defaultMessage: 'Select a Label Layout',
  },
  selectLabelLayoutBody: {
    id: 'TJ/9i7',
    description: 'Body for the select label layout engagement card',
    defaultMessage:
      'Let us know which label format and size works best for your business, and select your preference for packing slip printing. We’ll apply it to all of your labels across all of your carriers.',
  },
  selectLayoutButton: {
    id: 'gejbSI',
    description: 'button text to open label layout modal',
    defaultMessage: 'Set layout',
  },
  createShippingPresetsTitle: {
    id: 'NQuvsh',
    description: 'Title for the create shipping presets engagement card',
    defaultMessage: 'Create Shipping Presets',
  },
  createShippingPresetsBodyLineOne: {
    id: 'fTXRxt',
    description: 'Body for the create shipping presets engagement card',
    defaultMessage:
      'Once you connect a store, ShipStation will start importing orders regularly. To ensure you always see all your most recent orders, click the import icon {icon} at any time.',
  },
  createShippingPresetsBodyLineTwo: {
    id: '46WdKF',
    description: 'Body for the create shipping presets engagement card',
    defaultMessage: '<i>Order sync times vary depending on how many orders you have.</i>',
  },
  barcodePresetsTitle: {
    id: '3xMGaj',
    description: 'Title for the barcode presets engagement card',
    defaultMessage: 'Use Barcodes to Apply Presets',
  },
  barcodePresetsBody: {
    id: 'lxpC0j',
    description: 'Body for the barcode presets engagement card',
    defaultMessage:
      'If you assign Hotkeys to your presets, you can print the Hotkeys as barcodes so they can be scanned and quickly applied to orders. Just click Print Hotkeys and Barcodes in the Manage Presets screen to print the barcode sheet.',
  },
  printingWithConnectTitle: {
    id: 'fBWwx/',
    description: 'Title for the printing with connect engagement card',
    defaultMessage: 'Printing with ShipStation Connect',
  },
  printingWithConnectLineOne: {
    id: 'bg4NHG',
    description: 'First line of body for the printing with connect engagement card',
    defaultMessage:
      'ShipStation Connect is a downloaded application that passes print jobs from your ShipStation account to your printer hardware. Think of it as the bridge between the ShipStation database and your printer workstations.',
  },
  printingWithConnectLineTwo: {
    id: 'QIXIa6',
    description: 'Second line of body for the printing with connect engagement card',
    defaultMessage:
      'You are not required to use ShipStation Connect to print your documents from ShipStation, but it does make your printing process more efficient and versatile.',
  },
  goToInstallation: {
    id: 'HexrGI',
    description: 'Text for button that links to the installation page',
    defaultMessage: 'Go to Installation',
  },
  shopifyInventoryTitle: {
    id: '7Jvp6D',
    description: 'Title for the shopify inventory engagement card',
    defaultMessage: 'Shopify Inventory',
  },
  shopifyInventoryBody: {
    id: 'Bi1xn0',
    description: 'Body for the shopify inventory engagement card',
    defaultMessage:
      'Managing your inventory and shipping can be time-consuming and complex as an online business owner. However, by using Shopify’s <u>inventory management</u> features, you can view your remaining Shopify inventory stock count in ShipStation by setting your ShipStation Inventory Source to Shopify.',
  },
  insightsReportsTitle: {
    id: '+KXioH',
    description: 'Title for the insights reports engagement card',
    defaultMessage: 'Insights Reports',
  },
  insightsReportsBody: {
    id: '6FHAhZ',
    description: 'Body for the insights reports engagement card',
    defaultMessage:
      'The Reports section of the Insights page provides several pre-formatted reports you view directly in ShipStation, or export to a document such as PDF, CSV, Excel, or plain text. Each report has various filter options to help you export only the data you need.',
  },
  inventorySyncTitle: {
    id: 'hXAgnJ',
    description: 'Title for the inventory sync engagement card',
    defaultMessage: 'Inventory Sync',
  },
  inventorySyncBody: {
    id: 'KEWMYE',
    description: 'Body for the inventory sync engagement card',
    defaultMessage:
      'ShipStation supports synchronizing inventory across these supported selling channels: Amazon, BigCommerce, eBay, Etsy, Shopify, and Walmart. Activate Inventory Sync in the Add-On section of your account settings to easily manage your inventory across multiple platforms.',
  },

  hiddenCardsEmptyStateTitle: {
    id: 'sacetK',
    description: 'Title for the hidden cards empty state',
    defaultMessage: 'Your hidden cards will appear here.',
  },
  hiddenCardsEmptyStateBody: {
    id: 'Fq26Ln',
    description: 'Body for the hidden cards empty state',
    defaultMessage: 'When you hide a card, it will appear here along with any other cards you’ve hidden.',
  },
  activeCardsEmptyStateTitle: {
    id: 'HGEZTV',
    description: 'Title for the active cards empty state',
    defaultMessage: 'You overachiever!',
  },
  activeCardsEmptyStateBody: {
    id: 'AB1lbT',
    description: 'Body for the active cards empty state',
    defaultMessage: 'Check back soon for more helpful resources and alerts.',
  },
  activeCardsEmptyStateSSUniversity: {
    id: 'rEjlKQ',
    description: 'text to drive users to ShipStation University',
    defaultMessage: 'If you’re looking to learn more check out <link>ShipStation University</link>',
  },
  hideCard: {
    id: 'n2TmHj',
    description: 'Text for button that hides a card',
    defaultMessage: 'Hide',
  },
  addTaxIDTitle: {
    id: 'HNErh2',
    description: 'Title for the add your Tax ID number engagement card',
    defaultMessage: 'Add your tax & billing information',
  },
  addTaxIDBody: {
    id: '38Aml0',
    description: 'Body for the add your Tax ID number engagement card',
    defaultMessage:
      'ShipStation only offers B2B services. Per government guidelines, local taxes will be applied to those who do not provide a Tax number. To avoid this please enter your Tax ID information.',
  },
  addTaxIDButton: {
    id: 'tFZlfD',
    description: 'Button for the add your Tax ID number engagement card',
    defaultMessage: 'Add Tax ID',
  },
  demoOrderTitle: {
    description: 'Title for demo order engagement card',
    defaultMessage: 'Tour a Demo Order',
    id: 'oN8ic8',
  },
  demoOrderBody: {
    description: 'Body for demo order engagement card',
    defaultMessage:
      "We'll create a demo order for you to explore at your own pace, with guided tours to help you! Learn how to configure a label, split orders into multiple shipments, edit an order's details, and more.",
    id: 'U4T5YW',
  },
  demoOrderButton: {
    description: 'Button to create demo order',
    defaultMessage: 'Create Demo order',
    id: 'nltNXA',
  },
  openDemoOrder: {
    description: 'Button to open existing demo order',
    defaultMessage: 'Open Demo Order',
    id: 'oNBg9A',
  },
  loadingIndicator: {
    description: 'Loading indicator message for demo order creation',
    defaultMessage: 'One moment while we create your demo order for you!',
    id: '1ufvJv',
  },
});
